import { Controller } from "stimulus"

// Generic, reusable "dismiss and stay dismissed" behavior.
// Once the user dismisses the element, it stays hidden in that browser
// (persisted in localStorage under the provided key).
//
// Usage:
//   %div{data: { controller: "dismissible", "dismissible-key-value": "service-restored-2026-07" }}
//     %button{data: { action: "dismissible#dismiss" }} ×
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.isDismissed) {
      this.element.remove()
    }
  }

  dismiss() {
    if (this.hasKeyValue) {
      try {
        localStorage.setItem(this.storageKey, "1")
      } catch (e) {
        // localStorage unavailable (private mode / disabled) — dismiss for this view only
      }
    }
    this.element.classList.add("animate__fadeOut")
    setTimeout(() => this.element.remove(), 300)
  }

  get storageKey() {
    return `dismissed:${this.keyValue}`
  }

  get isDismissed() {
    try {
      return this.hasKeyValue && localStorage.getItem(this.storageKey) === "1"
    } catch (e) {
      return false
    }
  }
}
